import { Box, Card, CardProps, Divider, Typography, styled } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = {
  title?: React.ReactNode;
  divider?: boolean; // defaults to false
  actionButton?: React.ReactNode;
  isEdit: boolean;
  containerClassName?: string;
  titleClassName?: string;
} & Omit<CardProps, 'title'>;

export default function ContentBoxUi({
  children,
  title,
  divider = false,
  actionButton,
  isEdit,
  containerClassName,
  titleClassName,
  ...cardProps
}: PropsWithChildren<Props>) {
  return (
    <Card {...cardProps} className={containerClassName}>
      {title && (
        <>
          <PaddingContainer
            sx={{ pb: actionButton ? 0.5 : 0.1 }}
            display='flex'
            alignItems='baseline'
            justifyContent='space-between'
          >
            <Typography className={titleClassName} component={isEdit ? 'h3' : 'h2'} variant='h4'>
              {title}
            </Typography>
            {actionButton}
          </PaddingContainer>
          {divider && <Divider />}
        </>
      )}
      <PaddingContainer>{children}</PaddingContainer>
    </Card>
  );
}

export const PADDING = 1.6;
const PaddingContainer: typeof Box = styled(Box)(({ theme }) => ({
  padding: theme.spacing(PADDING),
}));
